const isDevelopment = process.env.NODE_ENV !== 'production'

module.exports = {
    // The application name, to be used when asking the configuration system for settings
    appName: 'SchoolAcademicYearHost',
    // These applications are referenced by the project in an unbuilt state, and require babel to also be run over them
    // @ts-ignore untyped array
    childApplications: [],
    requiredConfigKeys: [],
    isDevelopment
}
